<template>
  <select-input name="event"
                fa-class="cocktail"
                :label="label"
                :placeholder="placeholder"
                :options="options"
                class="event"
                v-model="val"
                :required="required"
                :ref="type"
  />
</template>

<script>
import selectInput from '@/components/frontoffice/form/baseInput/select'
import wrapperFormMethods from '@/components/frontoffice/mixins/wrapperFormMethods'

export default {
  components: {
    selectInput
  },
  mixins: [wrapperFormMethods],
  data () {
    return {
      label: 'seminar.form.event.label',
      placeholder: 'seminar.form.event.placeholder',
      options: [
        { value: 'seminarTraining', text: this.$t('seminar.form.event.seminar_training') },
        { value: 'confCongress', text: this.$t('seminar.form.event.conference_congress') },
        { value: 'icentiveTrip', text: this.$t('seminar.form.event.incentive_trip') },
        { value: 'eventReception', text: this.$t('seminar.form.event.event_reception') },
        { value: 'eventElse', text: this.$t('seminar.form.event.else') }
      ],
      val: this.value,
      type: 'select'
    }
  },
  props: {
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    val (newVal, oldVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
